import(/* webpackMode: "eager" */ "/home/runner/work/dhb-handball-net/dhb-handball-net/web/app/error.tsx");
